import { Text } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";

const ContactDetails = () => {
    const { t } = useTranslation("contact");

    return (
        <div>
            <Text block>
                {t("titles.contactUs").toUpperCase()}
            </Text>
            <Text block>
                {t("details.phone.title")} {t("details.phone.value")}
            </Text>
            <Text block>
                {t("details.email.title")} {t("details.email.value")}
            </Text>
        </div>
    );
};

export default ContactDetails;